import React, { useState } from 'react'
import ModalCancelarSuministro from './ModalCancelarSuministro'
import ModalConfirmarDespachoQxFarmacia from './ModalConfirmarDespachoQxFarmacia'
import ModalMensajeValidarEnfermeria from './ModalMensajeValidarEnfermeria'
import ModalVerSuministrosDespachosQxFarmacia from './ModalVerSuministrosDespachosQxFarmacia'
import ModalImprimirDespachosQxFarmacia from './ModalImprimirDespachosQxFarmacia'

const TablaDespachoQXFarmacia = ({item,validarEnfermeria,dataEnfermeria,actualizarTablaDespacho}) => {
    const [modalOnClickDespachar, setmodalOnClickDespachar]=useState(false)
    const [mensajeSeleccionarEnfermero, setmensajeSeleccionarEnfermero]=useState(false)
    const [modalOnVersuministros,setmodalOnVersuministros]=useState(false)
    const [modalOnCancelarSuministros,setmodalOnCancelarSuministros]=useState(false)
    const [modalOnImprimir, setmodalOnImprimir]=useState(false)

    const handleOnclickImprimir =()=>{
      setmodalOnImprimir(true)
    }

    const handleOnclickCancelarSuministros=()=>{
      setmodalOnCancelarSuministros(true)
    }
    const handleOnclickVersuministros=()=>{
      setmodalOnVersuministros(true)
    }
    const handleOnclickDespachar=()=>{
      //console.log(validarEnfermeria,'validaaaaa')
      if(validarEnfermeria === ''){
        setmodalOnClickDespachar(true)
      }else{
        setmensajeSeleccionarEnfermero(true)
      }
        
    }
    
  return (
    <tbody>
      <tr className=" divide-y divide-slate-700 ">
        <td>
        {/* <button
      
      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded flex items-center"
    >
       <svg className="w-6 h-6" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
       <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
</svg>
 </svg>
      <span className="ml-2">Imprimir</span>
    </button> */}
          
         
    
 </td>
 {/* (item.PQEdoDes === 'C') || (item.PQEdoDes === 'D') || (item.PQEdoDes === 'R') */}
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
          {(item.PQEdoDes === 'P') || ((item.PQEdoDes === 'R') && (item.PaqInd === 'G'))?
          <button
          onClick={handleOnclickDespachar}
          type="button"
          className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
        >
          Despachar
        </button>
          :
          null
          }
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
        {/* { */}
          {/* (item.PQEdoDes === 'D') || (item.PQEdoDes === 'R')? */}
          <button
            onClick={handleOnclickImprimir}
            type="button"
            className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
  <path stroke-linecap="round" stroke-linejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0110.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0l.229 2.523a1.125 1.125 0 01-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0021 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 00-1.913-.247M6.34 18H5.25A2.25 2.25 0 013 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 011.913-.247m10.5 0a48.536 48.536 0 00-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5zm-3 0h.008v.008H15V10.5z" />
</svg>

          </button>
          {/* :
          null */}
        {/*  } */}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
        {(item.PQEdoDes === 'C') ?
        null:
          <button
            onClick={handleOnclickVersuministros}
            type="button"
            className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          >
           ver suministros

          </button>
          
          }
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
        {(item.PQEdoDes === 'C') || (item.PQEdoDes === 'D') || (item.PQEdoDes === 'R')?
          null
          :
          <button
            onClick={handleOnclickCancelarSuministros}
            type="button"
            className="inline-block px-2 py-1.5 bg-red-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-red-700 hover:shadow-lg focus:bg-red-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-red-800 active:shadow-lg transition duration-150 ease-in-out"
          >
            Cancelar
          </button>
          }
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.ProCirCod? item.ProCirCod:null}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.MPTDoc? item.MPTDoc.trim(): null}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.MPCedu? item.MPCedu.trim():null}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.MPNOMC? item.MPNOMC.trim():null}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.ProFec? item.ProFec.split(' ')[0]:null}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.PaqCod? item.PaqCod.trim():null}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
          {item.PaqDes? item.PaqDes.trim():null}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.PQCantPaq? item.PQCantPaq:null}
        </td>
        <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
          {item.PQEdoDes === 'P'? 'Pendiente':null}
          {item.PQEdoDes === 'D'? 'Despachado':null}
          {item.PQEdoDes === 'C'? 'Cancelado':null}
          {item.PQEdoDes === 'R'? 'Despacho Parcial':null}
        </td>
      </tr>
      {modalOnClickDespachar? <ModalConfirmarDespachoQxFarmacia item={item} setmodalOnClickDespachar={setmodalOnClickDespachar} dataEnfermeria={dataEnfermeria} actualizarTablaDespacho={actualizarTablaDespacho}/>:null}
      {mensajeSeleccionarEnfermero? <ModalMensajeValidarEnfermeria setmensajeSeleccionarEnfermero={setmensajeSeleccionarEnfermero}/>:null}
      {modalOnVersuministros? <ModalVerSuministrosDespachosQxFarmacia setmodalOnVersuministros={setmodalOnVersuministros} item={item}/>:null}
      {modalOnCancelarSuministros? <ModalCancelarSuministro setmodalOnCancelarSuministros={setmodalOnCancelarSuministros} item={item} actualizarTablaDespacho={actualizarTablaDespacho}/>:null}
      {modalOnImprimir? <ModalImprimirDespachosQxFarmacia setmodalOnImprimir={setmodalOnImprimir} item={item}/>:null}
    </tbody>
  )
}

export default TablaDespachoQXFarmacia